import './notFound.css'
import Header from "../../components/header/header";

export default function NotFound(){
    return(
        <>
        <Header />
        <div className="content-wrapper pl-5 pr-5 pt-2">
            <h1 className="notFound-title">404</h1>
            <h3>OOPS! NÃO HÁ NADA AQUI</h3>
            <p>A página que você tentou encontrar não existe ou está fora do ar, para retornar a página principal <a href="/home"> clique aqui.</a></p>
        </div>
        </>
    )
}